(function () {
  if (window.__flockDeliveryInit) return;
  window.__flockDeliveryInit = true;

  var REQUIRE_BEFORE_CHECKOUT = true;

  var ATTR = { method: 'Delivery or Pickup', date: 'Delivery Date', time: 'Delivery Time' };
  var ISO_ATTR = '_delivery_date_iso';
  var CHECKOUT_SELECTORS = '[name="checkout"], a[href$="/checkout"], [data-delivery-checkout]';

  var WEEKDAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June',
                'July', 'August', 'September', 'October', 'November', 'December'];

  // "2026-09-08" -> local Date (avoids the UTC shift of new Date(iso))
  function toDate(iso) {
    var p = String(iso).split('-');
    return new Date(Number(p[0]), Number(p[1]) - 1, Number(p[2]));
  }

  // "2026-09-08" -> "Tuesday, 8 September 2026"
  function friendlyDate(iso) {
    if (!iso) return '';
    var d = toDate(iso);
    if (isNaN(d.getTime())) return '';
    return WEEKDAYS[d.getDay()] + ', ' + d.getDate() + ' ' + MONTHS[d.getMonth()] + ' ' + d.getFullYear();
  }

  function persistMany(attrs) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    });
  }

  function persist(name, value) {
    var attrs = {}; attrs[name] = value;
    return persistMany(attrs);
  }

  function fields(root) {
    return {
      method: root.querySelector('[data-delivery-field="method"]'),
      date: root.querySelector('[data-delivery-field="date"]'),
      time: root.querySelector('[data-delivery-field="time"]')
    };
  }

  function vals(root) {
    var f = fields(root);
    return {
      method: f.method ? f.method.value : '',
      date: f.date ? f.date.value : '',
      time: f.time ? f.time.value : ''
    };
  }

  function isComplete(root) {
    var v = vals(root);
    return !!(v.method && v.date && v.time && dateProblem(root, v.date) === '');
  }

  function cartContainerOf(el) {
    return el.closest('xo-cart, xo-cart-mini') || document.body;
  }

  // Returns '' when the date is acceptable, otherwise a message.
  function dateProblem(root, iso) {
    if (!iso) return '';
    var min = root.getAttribute('data-delivery-min') || '';
    var max = root.getAttribute('data-delivery-max') || '';
    if (min && iso < min) return 'The earliest date we can take is ' + friendlyDate(min) + '.';
    if (max && iso > max) return 'The latest date we can take is ' + friendlyDate(max) + '.';

    var blockedRaw = root.getAttribute('data-delivery-blocked-days') || '';
    if (blockedRaw) {
      var blocked = blockedRaw.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      var dow = String(toDate(iso).getDay());
      if (blocked.indexOf(dow) !== -1) {
        return 'Sorry, we do not take bookings on ' + WEEKDAYS[Number(dow)] + 's.';
      }
    }
    return '';
  }

  function errorEl(root) {
    var err = root.querySelector('[data-delivery-error]');
    if (err && !err.getAttribute('data-delivery-error-default')) {
      err.setAttribute('data-delivery-error-default', err.textContent.trim());
    }
    return err;
  }

  function showError(root, message) {
    var err = errorEl(root);
    if (!err) return;
    err.textContent = message || err.getAttribute('data-delivery-error-default');
    err.hidden = false;
  }

  function hideError(root) {
    var err = errorEl(root);
    if (!err) return;
    err.hidden = true;
    err.textContent = err.getAttribute('data-delivery-error-default');
  }

  function updateUI(root) {
    var v = vals(root);

    var summary = root.querySelector('[data-delivery-summary]');
    var summaryText = root.querySelector('[data-delivery-summary-text]');
    if (summary && summaryText) {
      if (v.method && v.date && v.time) {
        summaryText.innerHTML = v.method + ' \u2014 ' + friendlyDate(v.date) + ' at ' + v.time;
        summary.hidden = false;
      } else {
        summary.hidden = true;
      }
    }

    var reminder = root.querySelector('[data-delivery-reminder]');
    var reminderMethod = root.querySelector('[data-delivery-reminder-method]');
    if (reminder && reminderMethod) {
      if (v.method) {
        reminderMethod.textContent = v.method;
        reminder.hidden = false;
      } else {
        reminder.hidden = true;
      }
    }
  }

  function refreshReadyState() {
    document.querySelectorAll('[data-delivery-root]').forEach(function (root) {
      var ready = isComplete(root);
      cartContainerOf(root).setAttribute('data-delivery-ready', ready ? 'true' : 'false');
      updateUI(root);
      if (ready) hideError(root);
    });
  }

  // Keep the cart-page and drawer copies in sync when both are on screen.
  function syncTwins(field, value) {
    document.querySelectorAll('[data-delivery-field="' + field + '"]').forEach(function (el) {
      if (el.value === value) return;
      if (!value) { el.value = ''; return; }
      if (el.tagName === 'SELECT') {
        var has = Array.prototype.some.call(el.options, function (o) { return o.value === value; });
        if (has) el.value = value;
      } else {
        el.value = value;
      }
    });
  }

  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el || !el.getAttribute) return;
    var field = el.getAttribute('data-delivery-field');
    if (!field || !ATTR[field]) return;

    var root = el.closest('[data-delivery-root]');

    if (field === 'date') {
      var iso = el.value;
      var problem = root ? dateProblem(root, iso) : '';
      if (problem) {
        showError(root, problem);
        el.value = '';
        syncTwins('date', '');
        persistMany({ 'Delivery Date': '', '_delivery_date_iso': '' }).then(refreshReadyState);
        refreshReadyState();
        return;
      }
      if (root) hideError(root);
      syncTwins('date', iso);
      var payload = {};
      payload[ATTR.date] = friendlyDate(iso);
      payload[ISO_ATTR] = iso;
      persistMany(payload).then(refreshReadyState);
      refreshReadyState();
      return;
    }

    syncTwins(field, el.value);
    persist(ATTR[field], el.value).then(refreshReadyState);
    refreshReadyState();
  });

  if (REQUIRE_BEFORE_CHECKOUT) {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest(CHECKOUT_SELECTORS);
      if (!btn) return;
      var root = cartContainerOf(btn).querySelector('[data-delivery-root]');
      if (!root || isComplete(root)) return;
      e.preventDefault();
      e.stopImmediatePropagation();

      var v = vals(root);
      var problem = dateProblem(root, v.date);
      showError(root, problem || null);

      root.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var f = fields(root), order = ['method', 'date', 'time'];
      for (var i = 0; i < order.length; i++) {
        if (f[order[i]] && !f[order[i]].value) { f[order[i]].focus(); break; }
      }
    }, true); // capture phase, so we run before the theme's own handler
  }

  var scheduled = false;
  function scheduleRefresh() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () { scheduled = false; refreshReadyState(); });
  }

  document.addEventListener('DOMContentLoaded', refreshReadyState);
  new MutationObserver(scheduleRefresh).observe(document.documentElement, { childList: true, subtree: true });
  refreshReadyState();
})();